import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import { Alert, Button } from '@mui/material';
import * as React from 'react';

import { ContextStore } from '../store/contextStore';
import type { PairedEnvironment } from './sandboxTypes';

/** The persistent SANDBOX banner on every page of a sandbox's dashboard (DSEC D3; plan §2). "Back to production" is a
 *  plain link to the production dashboard, whose own session is still there (another origin): a sandbox session never
 *  signs anyone in to production. Production shows nothing. */
const SandboxBanner = () => {
    const { environment, pairedEnvironment, tourOperator } = React.useContext(ContextStore) as any;
    if (environment !== 'sandbox') {
        return null;
    }
    const production: PairedEnvironment | null = pairedEnvironment && pairedEnvironment.environment === 'production' ? pairedEnvironment : null;
    return (
        <Alert
            severity="warning"
            variant="outlined"
            icon={<ScienceOutlinedIcon fontSize="small" />}
            data-testid="sandbox-banner"
            sx={{ borderRadius: 0, borderLeft: 0, borderRight: 0, borderTop: 0, py: 0, alignItems: 'center' }}
            action={production ? (
                <Button color="inherit" size="small" href={production.dashboard_url} data-testid="back-to-production">
                    Back to production
                </Button>
            ) : undefined}
        >
            <strong>SANDBOX</strong>
            {tourOperator?.name ? ` · ${tourOperator.name}` : ''}
            {' '}— its messages stay in the outbox unless allowlisted.
            {production ? ` Production is ${production.name}.` : ''}
        </Alert>
    );
};

export default SandboxBanner;
